
import { _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje, _derivatModulDimenzije_prostaUnutrasnjaSirinaIzSpoljasnje, _derivatModulDimenzije_prostaUnutrasnjaVisinaIzSpoljasnje } from './ter-derivat-lib-terkk-uni-dimenzije';
import { terUtilsSelectModulWhere } from './ter-selectors';
import { _getParamsFromLib } from './ter-params-utils';
import { draftel_codecs_pack_terkk$modul } from './ter-draftel-codec-lib-terkk-modul';


export const derivat_modul_pripremi_pods_input_inherited_za_draftel = (virtel_k) => {
  console.log('derivat_modul_pripremi_pods_input_inherited_za_draftel(virtel_k)');
  console.log(virtel_k);
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za modul virtel
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$modul.default_pods_input_state(),

    sifrakomore: virtel_k.sifrakomore,
    vrstaprofila: virtel_k.vrstaprofila,
    flag_dvevelicine: virtel_k.flag_dvevelicine,

    // ksirinaunutrasnja: virtel_k.ksirinaunutrasnja, // NOVO 2023 iskljucujemo unutrasnju iz komore
    ksirinaspoljasnja: virtel_k.ksirinaspoljasnja,

    // kvisinaunutrasnja: virtel_k.kvisinaunutrasnja, // NOVO 2023 iskljucujemo unutrasnju iz komore
    kvisinaspoljasnja: virtel_k.kvisinaspoljasnja,

    // ksirina2unutrasnja: virtel_k.ksirina2unutrasnja, // NOVO 2023 iskljucujemo unutrasnju iz komore
    ksirina2spoljasnja: virtel_k.ksirina2spoljasnja,

    // kvisina2unutrasnja: virtel_k.kvisina2unutrasnja, // NOVO 2023 iskljucujemo unutrasnju iz komore
    kvisina2spoljasnja: virtel_k.kvisina2spoljasnja
  };
  console.log('return pods_input_inherited', pods_input_inherited);
  return pods_input_inherited;
};


export const derivat_modul_dopuni = (p) => {
  // SPECIJALNI KORAK
  // _____ dodajemo neke podatke koji su mu potrebni!
  let modul = {
    ...p,
    ..._getParamsFromLib("terkk$modul")
  };
  return modul;
}


export const derivatModulIdent = (m) => {
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva

  // derivat 1
  // AHU + ID (101,102...) + tipkomore(HIG HIGP HIGPF)
  x = {
    temp: ''
  };
  x.temp = 'M' + m.brojmodula + ' ' + 'AHU' + ' ' + m.parent_subkey;
  z["ident"] = x;

  return z;
}

export const derivatModulBrojModula = (k_subkey, draftel_arr) => {
  /*
  nije dobro da se koristi broj poslednjeg modula jer on ne mora da bude najveci broj. Tako da koristimo resenje gde uzimamo u obzir sve modula i sledeci racunamo da je najveci plus 1.
  */
  let moduliIzabraneKomore = terUtilsSelectModulWhere(k_subkey, draftel_arr);
  let brojSledecegModula = 1;
  // Sve brojeve modula u niz
  let nizBrojevaModula = [];
  moduliIzabraneKomore.forEach(m => {
    nizBrojevaModula.push(m.brojmodula);
  });
  // Ako niz nije prazan onda trazimo sledeci, ako je prazan vratice 1
  if (nizBrojevaModula.length > 0) {
    // Nadji max broj modula
    let maxBrojModula = Math.max(...nizBrojevaModula);
    // console.log('max ', maxBrojModula);
    brojSledecegModula = maxBrojModula + 1;
  }
  return brojSledecegModula;
}

export const derivatModulIdentModula = (virtel_k, brojModula) => {
  let sifraModula = virtel_k.sifrakomore + 'M' + brojModula;
  return sifraModula;
}

export const _derivat_modul_izracunaj_identModula = (sifrakomore, brojmodula) => {
  const siframodula = sifrakomore + 'M' + brojmodula;
  return siframodula;
}


//
export const derivat_modul_izracunaj_vrsta_pakovanja = (msirinaspoljasnja) => {
  /*
  Modul ide na paletu ide ukoliko je širina komore veća od 1220mm, ukoliko je širina modula manja ili jednaka od 1220mm onda je pakovanje klocna.

  Opcije Na modul i Na gredu su za sada custom varijante i ne postoji logika za odabir.
  */
  let modul_vrsta_pakovanja = null;
  if (msirinaspoljasnja > 0) {
    if (msirinaspoljasnja > 1220) {
      modul_vrsta_pakovanja = "PALETA";
    } else {
      modul_vrsta_pakovanja = "KLOCNA";
    }
  }
  return modul_vrsta_pakovanja;
};


export const _derivatModulDimenzije_finalneSirinaVisina = (pods_input, kojavelicina, flag_dimenzijemodulaunc, sirinamodulaunc, visinamodulaunc) => {
  console.log('_derivatModulDimenzije_finalneSirinaVisina(pods_input) ');
  console.log(pods_input); // modul pods_input
  // NAPOMENA: PO OLUCI 2021-09-08, kod modula i kad rucno upisujemo UNC dimenzija i kad biramo standardne Velicina 1 ili Velicina 2, uvek povlacimo spoljasnje dimenzije za modul

  // const flag_dvevelicine = pods_input.flag_dvevelicine;
  const vrstaprofila = pods_input.vrstaprofila;
  // const kojavelicina = pods_input.kojavelicina;
  // const flag_dimenzijemodulaunc = pods_input.flag_dimenzijemodulaunc; // NOVO AVGUST
  // const visinamodulaunc = pods_input.visinamodulaunc; // modul visina unc, ne bi bilo lose promeniti u mvisinamodulaunc TODO
  // const sirinamodulaunc = pods_input.sirinamodulaunc;
  /*
  // NOVO 2023 iskljucujemo unutrasnju iz komore
  const ksirinaunutrasnja = pods_input.ksirinaunutrasnja;
  const kvisinaunutrasnja = pods_input.kvisinaunutrasnja;
  const ksirina2unutrasnja = pods_input.ksirina2unutrasnja;
  const kvisina2unutrasnja = pods_input.kvisina2unutrasnja;
  */
  // NOVO AVGUST
  const ksirinaspoljasnja = pods_input.ksirinaspoljasnja;
  const kvisinaspoljasnja = pods_input.kvisinaspoljasnja;
  const ksirina2spoljasnja = pods_input.ksirina2spoljasnja;
  const kvisina2spoljasnja = pods_input.kvisina2spoljasnja;
  /*
  let k = {
    ...pods_input
  }; // privremeno da bi se u njemu lako nasli derivati od k kao sto su k.kvisinaspoljasnja, i slicni.
  */

  /*
  PROBLEMATIKA
  modul može imati velicinu 1 ili 2 ili UNCONSTRAINED

  UNC svakako treba imati flag i vec ga ima,

  velicina 1 ili 2 nije bitna za GENUS iz njih mora da se izvuce derivat koji uvek pokazuje tacne velicine modula koje ce da budu uzete u obzir za GENUS.

  */


  /*
    "ksirinaunutrasnjaizmedjupregradnih",
    "ksirinaunutrasnjaizmedjuosnovnih",
    "ksirinaunutrasnjaizmedjukrilaca",
    "ksirinaspoljasnja",
    "ksirina2oznaka",
    "ksirina2unutrasnja",
    "ksirina2unutrasnjaizmedjupregradnih",
    "ksirina2unutrasnjaizmedjuosnovnih",
    "ksirina2unutrasnjaizmedjukrilaca",
    */

  let unutrasnjaSirinaModula;
  let msirinaunutrasnjaizmedjupregradnih;
  let msirinaunutrasnjaizmedjuosnovnih;
  let msirinaunutrasnjaizmedjukrilaca;
  let unutrasnjaVisinaModula;
  let mvisinaunutrasnjaizmedjupregradnih;
  let mvisinaunutrasnjaizmedjuosnovnih;
  let mvisinaunutrasnjaizmedjukrilaca;
  let spoljasnjaSirinaModula;
  let spoljasnjaVisinaModula;

  if (kojavelicina === "1") {
    // ako je modul dimenzija komore "1"
    // unutrasnjaSirinaModula = ksirinaunutrasnja; // NOVO 2023 iskljucujemo unutrasnju iz komore
    // unutrasnjaVisinaModula = kvisinaunutrasnja; // NOVO 2023 iskljucujemo unutrasnju iz komore
    spoljasnjaSirinaModula = ksirinaspoljasnja;
    spoljasnjaVisinaModula = kvisinaspoljasnja;
  } else if (kojavelicina === "2") {
    // ako je modul dimenzija komore "2"
    // unutrasnjaSirinaModula = ksirina2unutrasnja; // NOVO 2023 iskljucujemo unutrasnju iz komore
    // unutrasnjaVisinaModula = kvisina2unutrasnja; // NOVO 2023 iskljucujemo unutrasnju iz komore
    spoljasnjaSirinaModula = ksirina2spoljasnja;
    spoljasnjaVisinaModula = kvisina2spoljasnja;
  };

  if (flag_dimenzijemodulaunc === true) {
    // ako je modul drugaciji od dimenzija komore
    // UNCONSTRAINED SIRINA MODULA (sirinamodulaunc) JE SPOLJASNJA
    spoljasnjaSirinaModula = sirinamodulaunc; // NOVO AVGUST
    // UNCONSTRAINED VISINA MODULA (visinamodulaunc) JE SPOLJASNJA
    spoljasnjaVisinaModula = visinamodulaunc; // NOVO AVGUST
  };

  // RACUNANJE UNUTRASNJIH IZ SPOLJASNJIH
  // BEZ OBZIRA DA LI JE Velicina standardna 1 ili 2 ili UNC
  const _unutrasnje_sirine = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(spoljasnjaSirinaModula, vrstaprofila);
  const _unutrasnje_visine = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(spoljasnjaVisinaModula, vrstaprofila);
  msirinaunutrasnjaizmedjupregradnih = _unutrasnje_sirine.unutrasnjaIzmedjuPregradnih;
  msirinaunutrasnjaizmedjuosnovnih = _unutrasnje_sirine.unutrasnjaIzmedjuOsnovnih;
  msirinaunutrasnjaizmedjukrilaca = _unutrasnje_sirine.unutrasnjaIzmedjuKrilaca;
  //
  mvisinaunutrasnjaizmedjupregradnih = _unutrasnje_visine.unutrasnjaIzmedjuPregradnih;
  mvisinaunutrasnjaizmedjuosnovnih = _unutrasnje_visine.unutrasnjaIzmedjuOsnovnih;
  mvisinaunutrasnjaizmedjukrilaca = _unutrasnje_visine.unutrasnjaIzmedjuKrilaca;
  //
  unutrasnjaSirinaModula = _derivatModulDimenzije_prostaUnutrasnjaSirinaIzSpoljasnje(spoljasnjaSirinaModula, vrstaprofila);
  unutrasnjaVisinaModula = _derivatModulDimenzije_prostaUnutrasnjaVisinaIzSpoljasnje(spoljasnjaVisinaModula, vrstaprofila);

  // Tek sada je pripremljeno da JE JASNO da je unutrasnja sirina zaista unutrasnja a spoljasnja zaista spoljasnja.

  // sad pravimo nove jasnije msirinaspoljasnja i mvisinaspoljasnja

  // RETURN DERIVATI
  const derivati = {
    msirinaunutrasnja: unutrasnjaSirinaModula, // ovde je sada jasno da je UNUTRASNJA
    msirinaunutrasnjaizmedjupregradnih: msirinaunutrasnjaizmedjupregradnih,
    msirinaunutrasnjaizmedjuosnovnih: msirinaunutrasnjaizmedjuosnovnih,
    msirinaunutrasnjaizmedjukrilaca: msirinaunutrasnjaizmedjukrilaca,
    mvisinaunutrasnja: unutrasnjaVisinaModula, // ovde je sada jasno da je UNUTRASNJA
    mvisinaunutrasnjaizmedjupregradnih: mvisinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjuosnovnih: mvisinaunutrasnjaizmedjuosnovnih,
    mvisinaunutrasnjaizmedjukrilaca: mvisinaunutrasnjaizmedjukrilaca,
    msirinaspoljasnja: spoljasnjaSirinaModula, // ovde je sada jasno da je SPOLJASNJA
    mvisinaspoljasnja: spoljasnjaVisinaModula, // ovde je sada jasno da je SPOLJASNJA
    // NOVO 2021 AGUST koristimo SPOLJASNJU kao standardnu
    sirinamodula: spoljasnjaSirinaModula, // NOVO 2021 AVGUST SPOLJASNJA
    visinamodula: spoljasnjaVisinaModula, // NOVO 2021 AVGUST SPOLJASNJA
  };
  console.log(derivati);
  return derivati;
};

